<template>
  <div class="notice">
    <!-- <div class="banner"> -->
      <img class="banner clearfix" :src="bannerInfo.pic" alt="">
      <div class="w flex" style="justify-content: space-between;height: 17rem;">
        <div class="ban_l">
          <div class="tit">通知公告</div>
          <div class="desc" v-html="bannerInfo.content"></div>
        </div>
        <!-- <div class="ban_r"></div> -->
      </div>
    <!-- </div> -->

    <div class="w notice_ti flex">
      <div class="title">通知公告 <span class="total">共{{total}}项</span></div>
      <a-input-search :allowClear="true" style="width: 299px;margin-left:20px;" placeholder="请输入你要查询的关键字..." enter-button @search="onSearch" />   
    </div>

    <div class="w" style="margin-bottom:40px;">
      <div class="notice_list flex" v-for="(item,index) in noticeList" :key="item.id">
          <div class="not_l">
            <div class="not_date">{{item.time.substring(8,10)}}</div>
            <div class="not_time">{{item.time.substring(0,7)}}</div>
          </div>
          <div class="not_r_box">
            <div class="blue_yuan"></div>
          <div class="not_r" :style="index != noticeList.length-1 ? 'border-bottom: 1px solid #E0E5F0; ':''">
            <div class="not_title">{{item.title}}</div>
            <div class="not_con" v-html="item.content"></div>
            <div class="check flex" @click="gotoDetails(item.id)">
              <div>查看详情</div>
              <img src="../../assets/icon/check.png" alt="">
            </div>
          </div> 
          </div>      
        </div>
    </div>
    <a-pagination
        v-model="current"
        class="w"
        :total="total"
        @change="pageChange"
      />
  </div>
</template>

<script>
import {findNoticeByKeywordApi,findNoticeBannerApi} from '@/api/index'
import { format } from '../../../utils/utils';
import imgPrefix from '../../../utils/imgPrefix';
export default {
  data() {
    return {
      noticeList:[],
      form:{},
      page:1,
      pageSize:10,
      total:0,
      keyword:'',
      current:1,
      imgPrefix,
      bannerInfo:{}
    };
  },
  created() {
    this.getFindNotice()
    // 获取banner
    findNoticeBannerApi().then(res => {
      // console.log(res);
      res.pic = this.imgPrefix+res.pic
      this.bannerInfo = res;
    })
  },
  methods: {
    // 获取公告列表
    getFindNotice(){
      let dto = {
        page:this.page,
        pageSize:this.pageSize,
        keyword:this.keyword
      }
      findNoticeByKeywordApi(dto).then(res => {
        // console.log(res);
        res.pageListVo.list.forEach(item => {
          item.time = format(item.createTime,'yyyy-MM-dd')
        });
        this.noticeList = res.pageListVo.list;
        this.total = res.pageListVo.total;
        this.current = res.pageListVo.page;
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    onSearch(e){
      this.page = 1;
      // console.log(e);
      this.keyword = e;
      this.getFindNotice()
    },
    gotoDetails(id){
      this.$router.push('/noticeDetails?noticeId=' + id);
    },
    // 切换页码
    pageChange(page, pageSize) {
      // console.log(page, pageSize);
      this.page = page;
      this.getFindNotice();
    },
  },
};
</script>

<style scoped lang="less">
.notice{
  .banner {
    width: 100%;
    height: 17rem;
    // background: url("../../assets/banner-color.png") no-repeat center;
    // background-size: cover;
    text-align: left;
    margin-bottom: 37px;
    position: absolute;
    left: 0;
    object-fit: cover; //保持原有尺寸比例。但部分内容可能被剪切。
  }
  .ban_l {
    margin-top: 0 !important;
  }
  // .ban_r {
  //   width: 43%;
  //   height: 272px;
  //   background: url("../../assets/banner-notice.png") no-repeat right;
  // }
  .notice_ti {
    justify-content: space-between;
    padding-bottom: 1%;
    margin-top: 3%;
  }
  .title {
    font-weight: 700;
    font-size: 28px;
    color: #0d1c28;
    text-align: left;
    .total {
      font-size: 18px;
      color: #7A8BA4;
      font-weight: 500;
    }
  }
  .notice_list{
    .not_l{
      flex: 1;
      .not_date{
        font-size: 24px;
        font-weight: 700;
        color: var(--themeColor);
        margin-bottom: 8px;
      }
      .not_time{
        color: #7A8BA4;
      }   
    }
    .not_r_box{
      flex: 9;
      border-left: 1px solid #E0E5F0; 
      padding-left: 24px;
      position: relative;
      .blue_yuan{
        width: 12px;
        height: 12px;
        background: var(--themeColor);
        border-radius: 50%;
        position: absolute;
        left: -6px;
        top: 44%;
      }
    }
    .not_r{
      text-align: left;
      padding: 24px;
           
      .not_title{
        font-size: 24px;
        flex-wrap: wrap;
      }
      .not_con{
        color: #7A8BA4;
        flex-wrap: wrap;
        overflow: hidden;
        -webkit-line-clamp: 2;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        margin: 16px 0 8px;
        max-height: 42px;        
        image{
          height: 50px;
        }
      }
      .check{
        font-size: 14px;
        color: var(--themeColor);
        cursor: pointer;
        img{
          margin-left: 12px;
        }
      }
    }
   
  }
}
/deep/.ant-btn-primary{
   background: var(--themeColor);
}
/deep/.ant-pagination {
  margin: 0 auto;
  padding-bottom: 85px;
  text-align: right;
}
</style>
